/**
 * Authentication utility functions for the support volunteer interface
 */

// Hardcoded password for the training environment
const OPERATOR_PASSWORD = 'Sekasinpäivystäjä';
const OPERATOR_PASSWORD_CLUSTER = 'cluster2025';
const OPERATOR_PASSWORD_MIELI = 'KriisiChat2026';

/**
 * Check if the provided password matches the operator password
 */
export const checkOperatorPassword = (password: string): boolean => {
  return (
    password === OPERATOR_PASSWORD ||
    password === OPERATOR_PASSWORD_CLUSTER ||
    password === OPERATOR_PASSWORD_MIELI
  );
};

/**
 * Check if the user is authenticated as a support volunteer
 */
export const isOperatorAuthenticated = (): boolean => {
  const isAuthenticated = localStorage.getItem('isOperatorAuthenticated');
  return isAuthenticated === 'true';
};

/**
 * Log out the support volunteer by removing the authentication flag
 */
export const logoutOperator = (): void => {
  localStorage.removeItem('isOperatorAuthenticated');
};
